const MIN_AGE = 18;
const MAX_AGE = 99;

export default {
	/**
	 * This function takes an age, and gives you a suggested age range to use in
	 * your What I Want settings. Funnily enough, it is essentially the algorithm
	 * from this XKCD comic: https://www.xkcd.com/314/
	 *
	 * @param {int} age - how old the user is
	 * @return {object} res - the results
	 * @return {int} res.minAge - the minimum age
	 * @return {int} res.maxAge - the maximum age
	 */
	getRangeFromAge(age) {
		if (typeof age !== "number") {
			return age;
		}

		let minAge = MIN_AGE;
		let maxAge = MAX_AGE;

		// half-age-plus-seven rule (but no younger than 18)
		minAge = (age / 2) + 7;
		minAge = Math.round(Math.max(minAge, MIN_AGE));

		// inverse of half-age-plus-seven rule (but no younger than 26)
		maxAge = (age - 7) * 2;
		maxAge = Math.min(MAX_AGE, Math.max(maxAge, 26));

		return {
			minAge,
			maxAge,
		};
	},

	/**
	 * Get an age from a birthday. Taken and modified from:
	 * https://stackoverflow.com/questions/4060004/calculate-age-given-the-birth-date-in-the-format-yyyymmdd
	 *
	 * @param {object} birthday - an object representing a birthday
	 * @param {number} birthday.year - the birth year
	 * @param {number} birthday.month - the birth month
	 * @param {number} birthday.day - the birth day
	 * @return {number} - the age
	 */
	getAgeFromBirthday(birthday) {
		if (
			typeof birthday !== "object" ||
			!birthday.year ||
			!birthday.month ||
			!birthday.day
		) {
			return MIN_AGE;
		}

		const today = new Date();
		const birthDate = new Date(`${birthday.year}/${birthday.month}/${birthday.day}`);
		const month = today.getMonth() - birthDate.getMonth();
		let age = today.getFullYear() - birthDate.getFullYear();

		if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
			age -= 1;
		}

		return age;
	},

	/**
	 * This function takes an object that represents a birtday, and returns an age
	 * range to use in  your What I Want settings. Funnily enough, it is
	 * essentially the algorithm from this XKCD comic: https://www.xkcd.com/314/
	 *
	 * @param {object} birthday - an object representing a birthday
	 * @param {number} birthday.year - the birth year
	 * @param {number} birthday.month - the birth month
	 * @param {number} birthday.day - the birth day
	 * @return {object} res - the results
	 * @return {int} res.minAge - the minimum age
	 * @return {int} res.maxAge - the maximum age
	 */
	getRangeFromBirthday(birthday) {
		const age = this.getAgeFromBirthday(birthday);
		return this.getRangeFromAge(age);
	},
};



// WEBPACK FOOTER //
// ./src/shared/util/WiwAgeRange.js